module.exports = "<p>\n  org-chart works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/org-chart/org-chart.component.html
// module id = 660
// module chunks = 1